let value = 0;
const debounce = (fn, timeout) => {
  clearTimeout(value);
  value = setTimeout(() => {
    fn();
  }, timeout);
};

export default debounce;
